export enum MessageCodes {
  SAME_PHONE = 'SAME_PHONE',
  ALREADY_PHONE = 'ALREADY_PHONE',
}
